// ── cache helpers ──────────────────────────────────────────
export const CALL_CONFIG_KEY = "sip_call_config"

export function getSipConfigCache() {
  try {
    const raw = sessionStorage.getItem(CALL_CONFIG_KEY)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export function setSipConfigCache(data) {
  try {
    sessionStorage.setItem(CALL_CONFIG_KEY, JSON.stringify(data))
  } catch {
    // sessionStorage full hoặc bị block → bỏ qua, không crash
  }
}

export function clearSipConfigCache() {
  sessionStorage.removeItem(CALL_CONFIG_KEY)
}

// Map SIP status code + cause sang message thân thiện
export const getSipErrorMessage = (cause, message) => {
  const status = message?.status_code
  const reason = message?.reason_phrase

  // Ưu tiên map theo status_code trước
  const statusMap = {
    404: "Số điện thoại không tồn tại",
    403: "Không có quyền thực hiện cuộc gọi",
    408: "Cuộc gọi hết thời gian chờ",
    480: "Thuê bao tạm thời không liên lạc được",
    486: "Thuê bao đang bận",
    487: "Cuộc gọi đã bị hủy",
    488: "Định dạng cuộc gọi không được hỗ trợ",
    500: "Lỗi hệ thống tổng đài",
    503: "Dịch vụ tổng đài không khả dụng",
    603: "Thuê bao từ chối cuộc gọi",
  }

  // Fallback map theo cause của JsSIP
  const causeMap = {
    "Not Found":           "Số điện thoại không tồn tại",
    "Busy":                "Thuê bao đang bận",
    "Rejected":            "Thuê bao từ chối cuộc gọi",
    "Unavailable":         "Thuê bao không liên lạc được",
    "No Answer":           "Không có người nghe máy",
    "Request Timeout":     "Cuộc gọi hết thời gian chờ",
    "canceled":            "Cuộc gọi đã bị hủy",
    "Connection Error":    "Lỗi kết nối mạng",
  }

  if (status && statusMap[status]) return statusMap[status]
  if (cause && causeMap[cause])    return causeMap[cause]

  // Fallback hiển thị reason gốc từ SIP server nếu có
  // return reason ? `Cuộc gọi thất bại: ${reason}` : "Cuộc gọi thất bại"
}